/*
 * Fix — product-card click not opening the product page
 * ------------------------------------------------------
 * Reported on the home "המוצרים הנמכרים ביותר" (best-sellers) cards: clicking
 * a card image does nothing — it never navigates to the product page.
 *
 * Root cause (confirmed in-browser): these cards use the double-image hover
 * swap (.product-item__image.double__image / <hover-images>). The product link
 * (<a class="product-link">) wraps the image, but on press the hover layer
 * swaps the image out from under the cursor, so:
 *     mousedown target = <img> (inside the anchor)
 *     mouseup   target = .product-item__image (the bare, NON-link container)
 * The browser fires the synthesized `click` on the nearest common ancestor of
 * the two — the non-link .product-item__image div — so the anchor never gets
 * the click and nothing navigates. (Verified: scrollLeft delta was 0, so this
 * is the image swap, not the grid-slider drag.)
 *
 * Fix (additive, minimal): a capture-phase click handler. It only acts when
 * the click did NOT already land inside an anchor (i.e. the broken case), the
 * pointer barely moved (so real swipes/drags are ignored), and the click was
 * not on an interactive control (button / quick-buy / form / swatch). In that
 * case it navigates to the card's own product link — exactly what the browser
 * would have done if the target hadn't desynced. Legitimate clicks that DO
 * hit the anchor, and real drag gestures, are left completely untouched.
 *
 * To remove: delete this file and its <script> in layout/theme.liquid.
 */
(function () {
  'use strict';
  if (!('closest' in Element.prototype)) return;

  var MOVE_THRESHOLD = 8; // px — beyond this it's a swipe/drag, not a tap
  var downX = 0;
  var downY = 0;

  document.addEventListener(
    'pointerdown',
    function (e) {
      downX = e.clientX;
      downY = e.clientY;
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      // Already landed on a real link — browser handles it, don't interfere.
      if (t.closest('a[href]')) return;

      // Real drag/swipe, not a tap — leave the slider alone.
      if (
        Math.abs(e.clientX - downX) > MOVE_THRESHOLD ||
        Math.abs(e.clientY - downY) > MOVE_THRESHOLD
      ) {
        return;
      }

      // Don't hijack genuine interactive controls inside the card.
      if (
        t.closest(
          'button, input, select, textarea, label, ' +
            '[data-quickbuy], [data-quick-view], [data-add-to-cart], ' +
            '.quick-view, .quickbuy, .product-form, .product-item__cta, ' +
            'product-form, .swatch, [data-swatch]'
        )
      ) {
        return;
      }

      // Only rescue clicks that fall on a product card's image/body.
      var item = t.closest('.product-item');
      if (!item) return;

      var link =
        item.querySelector('a.product-link[href]') ||
        item.querySelector('a[href*="/products/"]');
      if (!link || !link.href) return;

      window.location.href = link.href;
    },
    true
  );
})();
